import React from "react";
import {
  TextInput,
  SelectInput,
  ReferenceInput,
  Filter,
  useTranslate,
  SearchInput,
  BooleanInput,
} from "react-admin";
import { CLIENT_STATUSES } from "@local/constants/index.js";

const ClientFilter = (props) => {
  const t = useTranslate();
  const plugins = JSON.parse(localStorage.getItem("plugins"));
  const merchant_id = localStorage.getItem("id");
  const merchant = localStorage.getItem("name");
  const nonDefaultClientRequires = [
    plugins.datexPayment,
    plugins.datexCoupon,
    plugins.datexApiPayment,
  ];

  return (
    <Filter {...props}>
      {(merchant === "Chipo" || merchant === "PetrolCard") && (
        <SearchInput
          sx={{
            "& .MuiFilledInput-input": {
              paddingTop: "6.5%",
            },
          }}
          placeholder={t("resources.Client.source.search")}
          source="q"
          alwaysOn
          resettable
          inputProps={{ maxLength: 64 }}
        />
      )}
      <TextInput
        source="phone"
        alwaysOn
        resettable
        inputProps={{ maxLength: 12 }}
      />
      {merchant === "PetrolCard" && (
        <ReferenceInput alwaysOn source="category_id" reference="Category">
          <SelectInput
            optionText="name"
            optionValue="id"
            filter={{
              merchant_id: merchant_id,
            }}
            resettable
          />
        </ReferenceInput>
      )}
      <SelectInput
        alwaysOn
        resettable
        source="status"
        choices={Object.keys(CLIENT_STATUSES).map((status) => ({
          id: status,
          name: `resources.Client.source.status.${status}`,
        }))}
      />
      {nonDefaultClientRequires.every((plugin) => plugin === false) && (
        <ReferenceInput alwaysOn source="category_id" reference="Category">
          <SelectInput
            optionText="name"
            optionValue="id"
            filter={{
              merchant_id: merchant_id,
            }}
            resettable
          />
        </ReferenceInput>
      )}
      <BooleanInput
        label="resources.Client.fields.has_changes"
        source="has_changes"
        alwaysOn
        sx={{
          marginBottom: "2.3%",
          height: "48px",
          width: "100%",
          paddingLeft: "10px",
          paddingTop: "11px",
          borderBottom: "1px solid grey",
          backgroundColor: "rgba(0, 0, 0, 0.04)",
          color: "rgba(0, 0, 0, 0.6)",
        }}
      />
    </Filter>
  );
};

export default ClientFilter;
